import React from 'react'
import cn from 'classnames'
import * as s from './PartnersBlock.module.scss'
import Typography from '../Common/Typography'

interface Props {
  title: string
  onClick: () => void
}

const PartnersMoreBtn: React.FC<Props> = ({ title, onClick }) => {
  return (
    <div onClick={onClick} className={cn(s.partners_btn, s.partners_more_btn)}>
      <Typography variant={'h4'} className={s.partners_btn_title}>
        {title}
      </Typography>
    </div>
  )
}

export default PartnersMoreBtn
